// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"427":"c69f001e","453":"7c4804f7","667":"4bca8287","769":"384e38bc","856":"92730400","977":"ce626202"}[chunkId] + ".chunk.js";
};